import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaExchangeAlt, FaUsers } from 'react-icons/fa';
import './Sidebar.css';

export default function Sidebar() {
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <h2>Rekber Admin</h2>
            </div>
            <nav className="sidebar-nav">
                <ul>
                    <li className={isActive('/') ? 'active' : ''}>
                        <Link to="/">
                            <FaHome className="icon" style={{ color: '#FFFFFF' }} />
                            <span>Dashboard</span>
                        </Link>
                    </li>
                    <li className={isActive('/transactions') ? 'active' : ''}>
                        <Link to="/transactions">
                            <FaExchangeAlt className="icon" style={{ color: '#FFFFFF' }} />
                            <span>Transactions</span>
                        </Link>
                    </li>
                    <li className={isActive('/users') ? 'active' : ''}>
                        <Link to="/users">
                            <FaUsers className="icon" style={{ color: '#FFFFFF' }} />
                            <span>Users</span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
}
